module.exports = {
  "local": {
    "hotjar_id": "1864262",
    "stripe": {
      "public_key": "pk_test_ObQEKluWRi8MhJnXNoNfUOBP"
    },
    "firebase_config": {
      "apiKey": "AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM",
      "authDomain": "kaizen-80c12.firebaseapp.com",
      "databaseURL": "https://kaizen-80c12.firebaseio.com",
      "projectId": "kaizen-80c12",
      "storageBucket": "kaizen-80c12.appspot.com",
      "messagingSenderId": "950002077967",
      "appId": "1:950002077967:web:7df058a3f7584c88e3ae7a",
      "measurementId": "G-XWMPD4D2QF"
    },
  },
  "development": {
    "hotjar_id": "1864262",
    "stripe": {
      "public_key": "pk_test_ObQEKluWRi8MhJnXNoNfUOBP"
    },
    "firebase_config": {
      "apiKey": "AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM",
      "authDomain": "kaizen-80c12.firebaseapp.com",
      "databaseURL": "https://kaizen-80c12.firebaseio.com",
      "projectId": "kaizen-80c12",
      "storageBucket": "kaizen-80c12.appspot.com",
      "messagingSenderId": "950002077967",
      "appId": "1:950002077967:web:7df058a3f7584c88e3ae7a",
      "measurementId": "G-XWMPD4D2QF"
    },
  },
  "production": {
    "hotjar_id": "1864262",
    "stripe": {
      "public_key": "pk_test_ObQEKluWRi8MhJnXNoNfUOBP"
    },
    "firebase_config": {
      "apiKey": "AIzaSyATzt-ahKhPnN4e_VOibGdc21gbp2Uo5Qk",
      "authDomain": "app-kaizen-prod.firebaseapp.com",
      "databaseURL": "https://app-kaizen-prod.firebaseio.com",
      "projectId": "app-kaizen-prod",
      "storageBucket": "app-kaizen-prod.appspot.com",
      "messagingSenderId": "452591747226",
      "appId": "1:452591747226:web:174f7b3f67374c9745df23",
      "measurementId": "G-5FPP7S4SPW"
    },
  }
}
